import React from "react";
import { connect } from "react-redux";
import { getCollectMDLineItems, getPODetails, getPOLineItems, UpdatePCHM } from "../Actions/POViewAPI";
import Moment from "moment";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { DownloadDocument } from "../Actions/CommonAPI";
import { toast, ToastContainer } from "react-toastify";
import Popover from "react-bootstrap/Popover";
import Modal from 'react-bootstrap/Modal';
import { Paginator } from "primereact/paginator";
import { OverlayTrigger } from "react-bootstrap";

class POValidationMDSDoc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            IHMYes: false,
            IHMNo: false,
            keywords: "",
            PoConfirmation: {
                shipId: 0,
                purchaseOrderId: 0,
                poLineItemId: 0,
                ihmPresence: false,
                collectMdocSdoc: false,
                notApplicable: false,
                addKeyWords: false,
                keyword: [],
                modifiedBy: ""
            },
            EditAll: false,
            taskType: "",
            modalIsOpen: false,
            modalOpen: false,
            pchmall: [
                { id: 1, value: "Cadmium and Cadmium Compounds" },
                { id: 2, value: "Hexavalent Chromium and Hexavalent Chromium Compounds" },
                { id: 3, value: "Lead and Lead Compounds" },
                { id: 4, value: "Mercury and Mercury Compounds" },
                { id: 5, value: "Polybrominated Biphenyl (PBBs)" },
                { id: 6, value: "Polybrominated Dephenyl Ethers (PBDEs)" },
                { id: 7, value: "Polychloronaphthalanes (more than 3 chlorine atoms)" },
                { id: 8, value: "Radioactive Substances" },
                { id: 9, value: "Certain Shortchain Chlorinated Paraffins (Alkanes, C10-C13, chloro)" },
                // { id: 10, value: "Perfluorooctane sulfonic acid (PFOs)" },
                { id: 11, value: "Brominated Flame Retardant (HBCDD)" },
            ],
            checkedItems: [],
            pchmMaterial: []
        };
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkBoxClick = this.checkBoxClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        // this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    }

    componentDidMount() {
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        dispatch({ type: 'SubBannerTitle', data: "Awaiting MD & SDoC - Purchase Orders" });
        if (shipid !== "" && poid !== "") {
            dispatch(getPODetails(poid));
            dispatch(getCollectMDLineItems(poid));
        }
        if (history.location.pathname == `/Home/POViewEdit/${shipid}/${poid}`) {
            this.props.dispatch({ type: "EditPOView", data: true });
        }
    }

    handleChange(event) {
        let item = event.target.value;
        if (event.target.checked) {
            this.state.checkedItems.push(item);
        }
        else {
            var index = this.state.checkedItems.indexOf(item);
            this.state.checkedItems.splice(index, 1);
        }
        this.setState({});
    }

    handleRadioButtonChange(e) {

        let nodeName = e.target.name;
        if (nodeName === "IHMYes") {
            this.state.PoConfirmation.notApplicable = false;
            this.state.PoConfirmation.collectMdocSdoc = false;
            this.state.PoConfirmation.ihmPresence = true;
            this.setState({
                IHMYes: true,
                IHMNo: false,
            });
        } else if (nodeName === "IHMNo") {
            this.state.PoConfirmation.notApplicable = false;
            this.state.PoConfirmation.collectMdocSdoc = false;
            this.state.PoConfirmation.ihmPresence = false;
            this.setState({
                IHMYes: false,
                IHMNo: true,
            });
        } else if (nodeName === "notApplicable") {
            this.state.PoConfirmation.notApplicable = true;
            this.state.PoConfirmation.collectMdocSdoc = false;
            this.setState({
                IHMYes: false,
                IHMNo: false,
            });
        } else if (nodeName === "collectMdocSdoc") {
            this.state.PoConfirmation.notApplicable = false;
            this.state.PoConfirmation.collectMdocSdoc = true;
            this.setState({
                IHMYes: false,
                IHMNo: false,
            })
        }
    }

    handleInputChange(e) {

        // this.state.keywords=e.target.value;
        this.state.PoConfirmation.keyword = [e.target.value];
        this.setState({ keywords: e.target.value });
    }

    checkBoxClick(e) {

        let checked = this.state.isChecked;
        if (e.target.checked) {
            checked = true;
        }
        else {
            checked = false;
        }
        this.state.PoConfirmation.addKeyWords = checked;
        this.setState({});
    }

    toggle = (target) => {
        this.state.PoConfirmation.ihmPresence = false;
        this.state.PoConfirmation.collectMdocSdoc = false;
        this.state.PoConfirmation.notApplicable = false;
        this.state.PoConfirmation.addKeyWords = false;
        this.state.PoConfirmation.keyword = "";
        this.setState({
            [target]: !this.state[target],
            IHMYes: false,
            IHMNo: false,
            isChecked: false,
            keywords: ""
        });
    };

    confirmAll = (item) => {
        const { dispatch, match } = this.props;
        let POitems = {
            shipId: item.shipId,
            purchaseOrderId: item.purchaseOrderId,
            // poLineItemId: 0,
            ihmPresence: item.ihmPresence ? true : false,
            collectMdocSdoc: false,
            notApplicable: false,
            addKeyWords: false,
            keyword: [],
            modifiedBy: ""
        }

        confirmAlert({
            message: 'Are you sure want to confirm?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        let url = `${API.PoConfirmationAll}`;
                        axios.put(url, POitems)
                            .then((response) => {
                                dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                toast.success('Po confirmed successfully.', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                dispatch({
                                    type: "POConfirmationSuccess",
                                    data: response.data
                                })
                            })
                            .catch((error) => {
                                dispatch({
                                    type: "POConfirmationFailure",
                                    error: "ERROR"
                                })
                            })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    submitAll = (item) => {
        const { dispatch, match } = this.props;
        const { PoConfirmation, IHMYes, IHMNo } = this.state;
        let POitems = {
            shipId: item.shipId,
            purchaseOrderId: item.purchaseOrderId,
            // poLineItemId: 0,
            ihmPresence: this.state.PoConfirmation.ihmPresence,
            collectMdocSdoc: this.state.PoConfirmation.collectMdocSdoc,
            notApplicable: this.state.PoConfirmation.notApplicable,
            addKeyWords: this.state.PoConfirmation.addKeyWords,
            keyword: this.state.PoConfirmation.keyword,
            modifiedBy: this.state.PoConfirmation.modifiedBy
        }
        this.setState({
            EditAll: !this.state.EditAll,
        })
        if (PoConfirmation.collectMdocSdoc || PoConfirmation.notApplicable || IHMYes || IHMNo) {
            confirmAlert({
                message: 'Are you sure want to update?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => {
                            let url = `${API.PoConfirmationAll}`;
                            axios.put(url, POitems)
                                .then((response) => {
                                    dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                    toast.success('Po updated successfully.', {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                    dispatch({
                                        type: "POConfirmationSuccess",
                                        data: response.data
                                    })
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "POConfirmationFailure",
                                        error: "ERROR"
                                    })
                                })
                        }
                    },
                    {
                        label: 'No',
                        onClick: () => { }
                    }
                ]
            });
        } else {
            swal('Error!', 'Please select the option', 'warning');
        }
    }

    togglesubmit = (target, item) => {
        const { dispatch, match } = this.props;
        const { PoConfirmation, IHMYes, IHMNo } = this.state;
        this.setState({
            [target]: !this.state[target]
        });
        if (PoConfirmation.collectMdocSdoc || PoConfirmation.notApplicable || IHMYes || IHMNo) {
            confirmAlert({
                message: 'Are you sure want to update?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => {
                            this.state.PoConfirmation.shipId = item.shipId;
                            this.state.PoConfirmation.purchaseOrderId = item.purchaseOrderId;
                            this.state.PoConfirmation.poLineItemId = item.poLineItemId;
                            let url = `${API.PoConfirmation}`;
                            axios.put(url, PoConfirmation)
                                .then((response) => {
                                    dispatch(getPOLineItems(match.params.poid, this.state.taskType));
                                    toast.success('Po updated successfully.', {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                    dispatch({
                                        type: "POConfirmationSuccess",
                                        data: response.data
                                    })
                                })
                                .catch((error) => {
                                    dispatch({
                                        type: "POConfirmationFailure",
                                        error: "ERROR"
                                    })
                                })
                        }
                    },
                    {
                        label: 'No',
                        onClick: () => { }
                    }
                ]
            });
        } else {
            swal('Error!', 'Please select the option', 'warning');
        }
    };

    hideSidePanelAll = () => {
        this.setState({ modalIsOpen: false })
    }

    hideSidePanel = () => {
        this.setState({ modalOpen: false })
    }

    submitpchmall = () => {
        const { dispatch, match, CollectMDLineItems } = this.props;
        const { params } = match;
        const { poid } = params;
        let data = CollectMDLineItems.map((i) => ({
            shipId: i.shipId,
            purchaseOrderId: i.purchaseOrderId,
            poLineItemId: i.poLineItemId,
            ihmPresence: i.ihmPresence,
            collectMdocSdoc: false,
            notApplicable: false,
            isConfirmed: false,
            isPchm: true,
            addKeyWords: false,
            keyword: "",
            modifiedDate: "",
            modifiedBy: i.modifiedBy,
            pchmMaterials: this.state.checkedItems

        }));
        dispatch(UpdatePCHM(data, poid));
        this.state.modalIsOpen = false;
    }

    submitpchm = () => {        
        const { dispatch, match, history } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        let item = this.state.pchmMaterial;
        let data = [
            {
                shipId: item.shipId,
                purchaseOrderId: item.purchaseOrderId,
                poLineItemId: item.poLineItemId,
                ihmPresence: item.ihmPresence,
                collectMdocSdoc: false,
                notApplicable: false,
                isConfirmed: false,
                isPchm: true,
                addKeyWords: false,
                keyword: "",
                modifiedDate: "",
                modifiedBy: item.modifiedBy,
                pchmMaterials: this.state.checkedItems
            }]
        dispatch(UpdatePCHM(data, poid));
        this.state.modalOpen = false
    }

    // renderViewPopover1(props) {
    //     return (
    //         <Popover id="history-tooltip" {...props}>
    //             <Popover.Content>
    //                 <label style={{ padding: "0px 10px" }}>Edit All</label>
    //             </Popover.Content>
    //         </Popover>
    //     );
    // }

    // renderViewPopover(props) {
    //     return (
    //         <Popover id="history-tooltip" {...props}>
    //             <Popover.Content>
    //                 <label style={{ padding: "0px 10px" }}>Edit</label>
    //             </Popover.Content>
    //         </Popover>
    //     );
    // }

    render() {
        return (
            <div className="pb-3">
                {this.state.modalIsOpen ?
                    <Modal
                        size="md"
                        show={this.state.modalIsOpen}
                        onHide={() => this.setState({ modalIsOpen: false })}
                        aria-labelledby="example-modal-sizes-title-sm"
                        backdrop="static"
                        centered="true"
                        animation="true"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                PCHM ALL
              </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                this.state.pchmall.map(item => (
                                        <strong>
                                        <div className="row">
                                            <div className="col-sm-1 col-md-1 col-lg-1 pl-4">
                                                <input
                                                    type="checkbox"
                                                    value={item.value}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="col-sm-11 col-md-11 col-lg-11">
                                                <span>{item.value}</span>
                                            </div><br></br>
                                    </div>
                                        </strong>
                                ))
                            }
                            <div className="col-lg-12 text-right">
                                <button className="btn btn-primary text-uppercase txtside-btn blue mt-2" type="submit" onClick={() => this.submitpchmall()}> Submit </button>

                                <button className="btn btn-light text-uppercase txtside-btn ml-3 mt-2" type="button" onClick={() => this.hideSidePanelAll()}> Cancel </button>
                            </div>
                        </Modal.Body>
                    </Modal>
                    :
                    <Modal
                        size="md"
                        show={this.state.modalOpen}
                        onHide={() => this.setState({ modalOpen: false })}
                        aria-labelledby="example-modal-sizes-title-sm"
                        backdrop="static"
                        centered="true"
                        animation="true"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                PCHM
              </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                this.state.pchmall.map(item => (
                                        <strong>
                                        <div className="row">
                                            <div className="col-sm-1 col-md-1 col-lg-1 pl-4">
                                                <input
                                                    type="checkbox"
                                                    value={item.value}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="col-sm-11 col-md-11 col-lg-11">
                                                <span>{item.value}</span>
                                            </div><br></br>
                                    </div>
                                        </strong>
                                ))
                            }
                            <div className="col-lg-12 text-right">
                                <button className="btn btn-primary text-uppercase txtside-btn blue mt-2" type="submit" onClick={() => this.submitpchm()}> Submit </button>

                                <button className="btn btn-light text-uppercase txtside-btn ml-3 mt-2" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                            </div>
                        </Modal.Body>
                    </Modal>
                }

                {this.renderCardData()}

                {/* {arraylist.data.length != 0 ? (
                    <Paginator
                        first={this.state.first}
                        rows={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={(e) => this.onPaginatorChange(e)}
                    ></Paginator>
                ) : (
                        <div
                            className="card"
                            style={{ overflow: "hidden", position: "relative" }}
                        >
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Item to Display
                  </h6>
                            </div>
                        </div>
                    )} */}
            </div>
        );
    }

    hideSidePanels = () => {
        this.props.history.goBack();
    }

    renderCardData() {
        const { PODetail } = this.props;

        return (
            <div className="full-height px-4 pb-4">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanels()}
                >
                    &larr; Back
                        </button>
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
                            <div className="px-3 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row mx-0">
                                        <div className="col-sm-11 col-md-11 col-9 col-m-auto">
                                            <div className="row">
                                                <div className="col-md-4 py-1">
                                                    <h6 className="resource-list-title m-auto">
                                                        {PODetail ? PODetail.poNo : ""}
                                                    </h6>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>PR No : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.prNo : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>PO Date : </strong>
                                                        <span className="italicFont">{PODetail ? Moment(new Date(Date.parse(PODetail.poDate))).format('DD MMM YYYY') : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>Supplier Name : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.supplierName : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1" style={{ wordBreak: "break-all" }}>
                                                    <span>
                                                        <strong>Supplier Email : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.supplierEmail : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>Ship Name : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.shipName : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>PO Description : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.poDescription : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>Make : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.make : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-4 py-1">
                                                    <span>
                                                        <strong>Model : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.model : ""}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-1 col-md-1 col-3 col-m-auto text-right">
                                            {/* <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderViewPopover1()}>
                                                <i
                                                    className="fa fa-edit fa-3x click"
                                                    aria-hidden="true"
                                                    style={{ color: " #1E3A8A", fontSize: '1.8rem' }}
                                                    onClick={() => this.ShowSidePanel()}>
                                                </i>
                                            </OverlayTrigger> */}
                                            <button class="btn btn-primary btn-xs btn-conf-edit m-1" data-confirmation="confirm" style={{ width: "70px" }} onClick={() => this.ShowMaterialDeclaration("")}>
                                                Edit All
                                            </button>
                                            <button class="btn btn-secondary btn-xs btn-conf-edit m-1" data-confirmation="confirm" style={{ width: "80px" }} onClick={() => this.pchmall()}>
                                                PCHM All
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="panel-box">
                            <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <h5 className="card-title ml-2 my-2" style={{ color: "092a51" }}>
                                                {PODetail ? PODetail.poNo : ""}
                                            </h5>
                                        </div>
                                        <div className="col-sm-3">
                                            <h5 className="card-title ml-2 my-2" style={{ color: "092a51" }}>
                                                {PODetail ? PODetail.prNo : ""}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-2">
                                <div className="resource-list-auth-date">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span className="resource-list-title">{PODetail ? PODetail.poNo : ""}</span>
                                            <div className="row">
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>PR No : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.prNo : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-3 py-1">
                                                    <span>
                                                        <strong>PO Date : </strong>
                                                        <span className="italicFont">{PODetail ? Moment(new Date(Date.parse(PODetail.poDate))).format('DD MMM YYYY') : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-6 py-1">
                                                    <span>
                                                        <strong>Ship Name : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.poDescription : ""}</span>
                                                    </span>
                                                </div>
                                                <div className="col-md-12 py-1">
                                                    <span>
                                                        <strong>PO Description : </strong>
                                                        <span className="italicFont ">{PODetail ? PODetail.poDescription : ""}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-12">
                        <div className="card MM-card-header" style={{ backgroundColor: "white" }}>
                            <div className="card-body">
                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                    Line Items
                                </h5>
                            </div>
                        </div>
                        <div className="p-0">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.renderLineItemCard()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLineItemCard() {
        const { editPOView, CollectMDLineItems } = this.props;
        return CollectMDLineItems && CollectMDLineItems.length
            ? CollectMDLineItems.map((item, index) => {
                return (
                    <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
                        <div className="px-3 py-2">
                            <div className="resource-list-auth-date">
                                <div className="row mx-0">
                                    <div className="col-sm-10 col-md-10 col-9 col-m-auto">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <h6 className="resource-list-title m-auto mb-0" style={{ cursor: "pointer" }}
                                                >
                                                    {item.itemDescription}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2 col-md-2 col-3 col-m-auto text-right">
                                        {/* <OverlayTrigger
                                            placement="bottom"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={this.renderViewPopover()}>
                                            <i
                                                className="fa fa-edit fa-3x click"
                                                aria-hidden="true"
                                                style={{ color: " #1E3A8A", fontSize: '1.8rem' }}
                                                onClick={() => this.ShowSidePanel(item.shipId, item)}>
                                            </i>
                                        </OverlayTrigger> */}

                                        <button class="btn btn-primary btn-xs btn-conf-edit m-1" data-confirmation="confirm" onClick={() => this.ShowMaterialDeclaration(item)}>
                                            Edit
                                        </button>
                                        <button class="btn btn-secondary btn-xs btn-conf-edit m-1" data-confirmation="confirm" style={{ width: "70px" }} onClick={() => this.pchm(item)}>
                                            PCHM
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }) :
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                <div class="container">
                    <h6 className="resource-list-title no-item-card">
                        No Items
                </h6>
                </div>
            </div>;
    }

    downloadAttachment = (FileName, Guid) => {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(FileName, Guid));
    }

    ShowMaterialDeclaration = (item) => {
        const { dispatch, history } = this.props;
        if (item === "") {
            dispatch({ type: "MDSDocCollectAll", data: true });
        } else {
            dispatch({ type: "MDSDocCollectAll", data: false });
        }
        history.push(`/Home/MDCollect/${item.poLineItemId ? item.poLineItemId : 0}`);
        dispatch({ type: "POLineItem", data: item });
        dispatch({ type: "AttachmentUploadMDocSuccess", data: null });
        dispatch({ type: "AttachmentUploadSDocSuccess", data: null });
    }

    pchmall = () => {
        this.setState({ modalIsOpen: true });
    }

    pchm = (item) => {
        this.setState({ modalOpen: true, pchmMaterial: item })
    }

}

function mapStateToProps(state) {
    return {
        //BY BALU MOORTHI
        PODetail: state.POViewReducer.PODetail,
        CollectMDLineItems: state.POViewReducer.CollectMDLineItems,
        editPOView: state.SidePanReducer.EditPOView || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(POValidationMDSDoc);
